import mixins from '@synergycms_core/less/mixins';
export default {
  closeButton: {},
  selected: {},
  zoomButton: {},
  serviceInfoWithImage: {},
  buttonImage: {},
  photoCounter: {},
  availModalcontent: {},
  modalTabsList: {},
  headerModal: {},
  infoBlock: {},
  roomAmenities: {},
  hotelModalStyle: {
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    zIndex: '600',
    background: 'rgba(0,0,0,0.5)',
    padding: '0',
    '& $availModalcontent': {
      '@media (min-width:801px)': {
        right: '0',
        width: '600px',
        WebkitTransition: '0.5s',
        OTransition: '0.5s',
        MsTransition: '0.5s',
        MozTransition: '0.5s',
        transition: '0.5s',
        left: 'auto'
      },
      position: 'absolute',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0',
      overflow: 'auto',
      background: '#fff',
      '& $closeButton': {
        position: 'fixed',
        right: '10px',
        top: '10px',
        height: '24px',
        width: '24px',
        background: 'transparent',
        border: 'none',
        zIndex: '502',
        '& > span': {
          font: '15px Icons'
        },
        '&:lang(ar)': {
          right: 'auto',
          left: '10px',
          '@media(min-width:801px)': {
            right: 'auto',
            left: '30px',
          }
        },
        '@media(min-width:801px)': {
          right: '30px',
          top: '30px'
        }
      },
      '& $modalTabsList': {
        '& $headerModal': {
          '@media (min-width:801px)': {
            fontSize: '24px',
            padding: '30px 60px 10px 30px'
          },
          font: "18px 'Droid Serif'",
          padding: '10px 40px 10px 20px',
          textAlign: 'left',
          position: 'sticky',
          top: '0',
          background: '#fff',
          zIndex: '501',
          '&:lang(ar)': {
            paddingRight: "20px",
            paddingLeft: "40px",
            textAlign: "right",
            '@media (min-width: 801px)': {
              paddingLeft: "60px",
              paddingRight: "30px",
              textAlign: "right"
            }
          }
        },
        '& $zoomButton': {
          backgroundColor: 'black',
          padding: '15px',
          borderRadius: '50px',
          position: 'absolute',
          left: '0px',
          bottom: '0px',
          '&:lang(ar)': {
            left: 'auto',
            right: 0
          }
        }
      },
      '& $infoBlock': {
        font: "300 13px 'Roboto',sans-serif",
        background: '#fff',
        color: '#000',
        '& $serviceInfoWithImage': {
          '& button': {
            width: '100%',
            height: '47px',
            position: 'relative',
            paddingLeft: '20px',
            borderTop: '1px solid #ccc',
            textAlign: 'left',
            '&:lang(ar)': {
              textAlign: "right",
              paddingLeft: "0",
              paddingRight: "20px",
              '@media (min-width: 801px)': {
                paddingLeft: "0",
                paddingRight: "30px"
              }
            },
            '& > span': {
              fontSize: '16px',
              fontWeight: '500',
              '& > span': {
                font: '12px/1px Icons',
                position: 'absolute',
                right: '20px',
                top: '50%',
                '&:lang(ar)': {
                  right: 'auto',
                  left: '20px',
                  '@media (min-width: 801px)': {
                    right: 'auto',
                    left: '30px'
                  }
                },
                '@media (min-width:801px)': {
                  right: '30px'
                }
              },
              '@media (min-width:801px)': {
                fontSize: '24px',
              }
            },
            '@media (min-width:801px)': {
              height: '65px',
              paddingLeft: '30px',
            }
          },
          '& > span': {
            padding: '0 20px 12px',
            display: 'block',
            textAlign: 'left',
            '& p': {
              margin: '0',
              fontSize: '13px',
              '@media (min-width:801px)': {
                fontSize: '16px',
                lineHeight: '1.25'
              }
            },
            '&:lang(ar)': {
              textAlign: 'right'
            },
            '@media (min-width:801px)': {
              padding: '0 30px 20px'
            }
          },
          '& $roomAmenities': {
            overflow: 'hidden',
            maxHeight: '1000px',
            color: '#666',
            padding: '0 20px 13px',
            '@media (min-width:801px)': {
              overflow: 'hidden',
              maxHeight: '1000px',
              color: '#666',
              padding: '0 20px 13px'
            }
          }
        }
      },
      '&:lang(ar)': {
        '@media (min-width: 801px)': {
          right: 'auto',
          left: '0'
        }
      }
    }
  },
  availRoomDetailTabButton: {
    position: 'absolute',
    right: '20px',
    top: '50%',
    '@media (min-width:801px)': {
      right: '30px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: '20px',
      '@media (min-width:801px)': {
        left: '30px',
        right: 'auto'
      },
    }
  },
  availRoomDetailTab:{
    position:'relative'
  },
  mediaBlock: {
    position: 'relative',
    iframe: {
      padding: '20px',
      height: '160px',
      width: '100%',
      boxSizing: 'border-box',
      '@media (min-width:801px)': {
        height: '310px'
      }
    }
  },
  modalIFrame: {
    width: '100%',
    aspectRatio: '16 / 9',
    height: 'auto',
    marginTop: '20px',
    display: 'block',
    border: 'none',
  },
  enlargeButton: {
    position: 'absolute',
    bottom: '20px',
    left: '20px',
    right: '20px',
    top: '20px',
    zIndex:500,
    '@media (min-width:801px)': {
      bottom: '40px',
      left: '30px',
      right: '30px',
      top: '30px',
    },
    '& $buttonImage': {
      position: 'absolute',
      top: '0',
      left: '0',
      right:'0',
      bottom:'0',
      '@media (min-width:801px)': {
        width:'100%',
        height:'310px'
      },
    },
    '&:lang(ar)': {
      right: '30px',
    },
  },
  topButton: {
    width: '40px',
    height: '40px',
    bottom: '100%',
    position: 'absolute',
    right: '0',
    borderBottom: '1px solid #fff',
    borderBottomColor: 'rgba(255,255,255,0.6)',
    top: 'auto',
    marginTop: '0',
    zIndex:501,
    '& > span': {
      color: 'white',
      borderBottomColor: 'rgba(255,255,255,0.6)',
      fontSize: '9px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: 0
    }
  },
  botButton: {
    width: '40px',
    height: '40px',
    position: 'absolute',
    right: '0',
    top: '100%',
    left: 'auto',
    marginTop: '0',
    zIndex:501,
    '& > span': {
      color: 'white',
      borderBottomColor: 'rgba(255,255,255,0.6)',
      fontSize: '9px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: 0
    }
  },
  detailModal: {
    padding: '20px',
    boxSizing: 'border-box',
    '& > div': {
      height: '160px!important',
      overflow:'hidden',
      '& > div > div': {
        backgroundSize: 'cover!important'
      },
      '@media(min-width:801px)': {
        height: '310px!important'
      }
    },
    '@media(min-width:801px)': {
      padding: '30px 30px 40px!important',
      '& > div': {
        height: '310px!important'
      }
    }
  },
  monoHotelList: {
    extend: mixins.boxSizing(),
    margin: '0',
    padding: '0 20px',
    display: 'block',
    borderSpacing: '1px 0',
    width: '100%',
    borderBottom: '1px solid #d8d8d8',
    textAlign: 'left',
    '& > li': {
      display: 'inline-block',
      verticalAlign: 'bottom',
      textAlign: 'center',
      width: '30%',
      listStyle: 'none',
      '&:not(:first-of-type)': {
        marginLeft: '20px'
      },
      '&:only-child':{
        width:'auto'
      },
      '&:first-of-type:nth-last-child(2)':{
        width:'40%'
      },
      '&:nth-of-type(2)':{
        width:'40%'
      },
      '&:nth-of-type(2):nth-last-child(2)':{
        width:'30%'
      },
      '& button': {
        font: "13px 'Roboto',sans-serif",
        textTransform: 'uppercase',
        padding: '10px',
        minHeight: '42px',
        position: 'relative',
        width: '100%',
        '& span:first-of-type': {
          font: '18px Icons',
          position: 'relative',
          marginRight: '3px',
          '@media (min-width:801px)': {
            fontSize: '24px'
          },
          '&:lang(ar)':{
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            flexDirection: 'row-reverse',
          }
        },
        '& span': {
          verticalAlign: 'middle',
          fontSize: '13px',
          '@media (min-width:801px)': {
            fontSize: '16px'
          },
          '&:lang(ru)':{
            '@media (min-width:801px)': {
              fontSize: '11px'
            },
          },
          '&:lang(hu)':{
            '@media (min-width:801px)': {
              fontSize: '12px'
            },
          }
        },
        '& $photoCounter': {
          color: '#9b9b9b',
          '@media (max-width:450px)': {
            display: 'none'
          }
        }
      }
    },
    '@media (min-width:801px)': {
      padding: '0 30px'
    },
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  paddingTravelClub:{
    paddingRight: '160px',
    '&:lang(ar)': {
      paddingLeft: '160px',
    }
  },
  mediaExtraIcons: {
    position: 'absolute !important',
    top: 'auto !important',
    left: '45px !important',
    right: 'auto !important',
    bottom: '10px !important',
    zIndex: 2,
    display: 'flex !important',
    alignItems: 'center',
    gap: '4px',
  },
  mediaExtraIconsNoGallery: {
    left: '5px !important',
  },
  buttonImageVideo: {
    position: 'static !important',
    width: '36px !important',
    height: '36px !important',
    boxSizing: 'border-box',
    background: 'rgba(0,17,27,.6) !important',
    borderRadius: '50%',
    border: 'none !important',
    cursor: 'pointer',
    margin: '0 !important',
    padding: '0 !important',
    '& > span': {
      position: 'static !important',
      left: 'auto !important',
      bottom: 'auto !important',
      background: 'none !important',
      width: 'auto !important',
      height: 'auto !important',
      fontSize: '22px !important',
      lineHeight: '36px !important',
      color: '#fff',
    },
  },
  buttonImage360: {
    position: 'static !important',
    width: '36px !important',
    height: '36px !important',
    boxSizing: 'border-box',
    background: 'rgba(0,17,27,.6) !important',
    borderRadius: '50%',
    border: 'none !important',
    cursor: 'pointer',
    margin: '0 !important',
    padding: '0 !important',
    '& > span': {
      position: 'static !important',
      left: 'auto !important',
      bottom: 'auto !important',
      background: 'none !important',
      width: 'auto !important',
      height: 'auto !important',
      fontSize: '22px !important',
      lineHeight: '36px !important',
      color: '#fff',
    },
  },
};
